export enum GiftType {
    GIFT_DICE_ROLLS = "GIFT_DICE_ROLLS",
    GIFT_SHIELDS = "GIFT_SHIELDS",
    GIFT_PIGGY_WHEEL = "GIFT_PIGGY_WHEEL"
}